import BaseInputComponent from './BaseInputComponent.vue';
export default {
  extends: BaseInputComponent,
  props: {
    loading: Boolean
  }
};